import {
  IQuoteRespSchema,
  QuoteOfferingProps,
  QuoteStatusEnum,
} from '@monetize/types/app';
import { MBox } from '../../../components/Monetize';
import QuoteOffering from './components/quoteOffering/QuoteOffering';
import { QuoteOfferingDraggable } from './components/quoteOffering/QuoteOfferingDraggable';

interface QuoteFormOfferingRowProps extends Pick<
  QuoteOfferingProps,
  | 'index'
  | 'quoteOffering'
  | 'onChange'
  | 'childQuoteOfferings'
  | 'quotePrices'
  | 'quoteOfferings'
  | 'isOfferingOpen'
  | 'onIsOfferingOpenChange'
  | 'expandRatesSignal'
> {
  dragIndex: number;
  quote?: IQuoteRespSchema | null;
  moveOffering: (dragIndex: number, hoverIndex: number) => void;
  saveMoveOffering: () => void;
  /**
   * Drag-reorder is disabled while quote offering groups exist — relocation
   * happens via the group menu actions instead.
   */
  isDraggable?: boolean;
}

export const QuoteFormOfferingRow = ({
  quoteOffering,
  quote,
  childQuoteOfferings,
  quotePrices,
  onChange,
  index,
  dragIndex,
  moveOffering,
  saveMoveOffering,
  quoteOfferings,
  isOfferingOpen,
  onIsOfferingOpenChange,
  expandRatesSignal,
  isDraggable = true,
}: QuoteFormOfferingRowProps) => {
  if (!quoteOffering?.id) {
    return null;
  }

  const offering = (
    <QuoteOffering
      quoteOffering={quoteOffering}
      childQuoteOfferings={childQuoteOfferings}
      index={index}
      quotePrices={quotePrices}
      onChange={onChange}
      quoteOfferings={quoteOfferings}
      isOfferingOpen={isOfferingOpen}
      onIsOfferingOpenChange={onIsOfferingOpenChange}
      expandRatesSignal={expandRatesSignal}
    />
  );

  // Offerings are rounded strips rather than divider-separated rows, so the
  // gap between them comes from this wrapper (it also covers scheduled-change
  // segments, which QuoteOffering renders as trailing siblings).
  return (
    <MBox pb={1}>
      {quote?.status === QuoteStatusEnum.DRAFT && isDraggable ? (
        <QuoteOfferingDraggable
          index={dragIndex}
          quoteOffering={quoteOffering}
          moveOffering={moveOffering}
          saveMoveOffering={saveMoveOffering}
        >
          {offering}
        </QuoteOfferingDraggable>
      ) : (
        offering
      )}
    </MBox>
  );
};
